
import { Vue, Options } from "vue-class-component";

@Options({
  mounted: function () {
    //     let projectsStr = localStorage.getItem("projects") || "[]";
    //     let projects = JSON.parse(projectsStr);
    //     this.$data.projects = Object.values(projects);
    //     console.log(projects);

    let projectsStr = localStorage.getItem("projects") || "[]";
    let projects = JSON.parse(projectsStr);
    const id = this.$route.params.id;

    this.$data.project = projects[id];
  },
  components: {},
  data: function () {
    return {
      project: null,
    };
  },
})
export default class EditProject extends Vue {}
